import React, { useState, useEffect } from 'react';

function ImageLightbox({ photos, currentIndex, onClose, onIndexChange }) {
  const [index, setIndex] = useState(currentIndex);
  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  useEffect(() => {
    setIndex(currentIndex);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  }, [currentIndex]);

  const handlePrevious = () => {
    const newIndex = index > 0 ? index - 1 : photos.length - 1;
    setIndex(newIndex);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
    if (onIndexChange) onIndexChange(newIndex);
  };

  const handleNext = () => {
    const newIndex = index < photos.length - 1 ? index + 1 : 0;
    setIndex(newIndex);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
    if (onIndexChange) onIndexChange(newIndex);
  };

  const handleMouseDown = (e) => {
    if (zoom > 1) {
      setIsDragging(true);
      setDragStart({ x: e.clientX - position.x, y: e.clientY - position.y });
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging && zoom > 1) {
      setPosition({ x: e.clientX - dragStart.x, y: e.clientY - dragStart.y });
    }
  };

  const handleMouseUp = () => setIsDragging(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') handlePrevious();
      if (e.key === 'ArrowRight') handleNext();
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [index]);

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <button className="lightbox-close" onClick={onClose}>&times;</button>
      
      <button className="lightbox-nav lightbox-prev" onClick={(e) => { e.stopPropagation(); handlePrevious(); }}>
        &#8249;
      </button>
      
      <div 
        className="lightbox-content" 
        onClick={(e) => e.stopPropagation()}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >
        {photos[index].isVideo ? (
          <video 
            src={photos[index].url}
            controls
            autoPlay
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              objectFit: 'contain'
            }}
          />
        ) : (
          <img 
            src={photos[index].url} 
            alt=""
            style={{
              transform: `scale(${zoom}) translate(${position.x / zoom}px, ${position.y / zoom}px)`,
              cursor: zoom > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default',
              touchAction: 'pinch-zoom'
            }}
            draggable={false}
          />
        )}
      </div>
      
      <button className="lightbox-nav lightbox-next" onClick={(e) => { e.stopPropagation(); handleNext(); }}>
        &#8250;
      </button>
    </div>
  );
}

export default ImageLightbox;
